module.exports = __webpack_public_path__ + "img/landing-step2.fd7a92da.svg";